import React, { useMemo } from 'react';
import ProductList from './ProductList';
import { AlbumState } from '@/data/models/albumState';
import { useTranslation } from 'react-i18next';
import { loadMerchandiseReleasesFilters } from '@/state/actions/productGridActions';
import { FormatType } from '@/data/models/formatType';
import store from '@/state/store';
import { merchandiseProductListColDef } from './MerchandiseProductListColDef';
import { useSelector } from 'react-redux';
import { getAuth } from '@/selectors/auth';
import { withActiveChangeRequestColumn } from './ChangeRequestColumn';

const defaultMerchandiseStateFilters = [AlbumState.Released];

export default function MerchandiseList() {
  const { t } = useTranslation();
  const { hasInternalAccess } = useSelector(getAuth);

  const storemerchandiseReleasesGridParams = (
    searchParams: URLSearchParams | null
  ) => {
    return loadMerchandiseReleasesFilters({
      merchandiseReleasesGridParams: searchParams,
    });
  };

  const merchandiseReleasesGridParams =
    store.getState().productGridState.merchandiseReleasesGridParams;
  const merchandiseReleasesProductListColDef = useMemo(
    () =>
      withActiveChangeRequestColumn(
        merchandiseProductListColDef,
        hasInternalAccess
      ),
    [hasInternalAccess]
  );

  return (
    <ProductList
      defaultStateFilters={defaultMerchandiseStateFilters}
      productListHeader={t('product.productList.merchandiseReleases')}
      storedGridParams={merchandiseReleasesGridParams}
      setGridParams={storemerchandiseReleasesGridParams}
      formatType={FormatType.Merchandise}
      productListColDef={merchandiseReleasesProductListColDef}
      gridName="merchandise-releases"
    />
  );
}
